import React from 'react';
import PortfolioMonitorContextProvider, { usePortfolioMonitorContext }
  from '@/finsight/application/PortfolioMonitor/PortfolioMonitorContext';
import PortfoliosContextProvider, { usePortfoliosContext }
  from '@/finsight/application/PortfolioMonitor/PortfoliosContext';
import PortfolioContent from './PortfolioContent';
import getPortfolioMonitorOverlay from '@/finsight/ui/components/portfolioMonitor/getPortfolioMonitorOverlay';
import ManagePortfoliosContextProvider from '@/finsight/application/PortfolioMonitor/ManagePortfoliosContext';

const PortfolioMonitor = () => {
  const { isFormOpened } = usePortfolioMonitorContext();
  const { portfolioCollection } = usePortfoliosContext();

  return (
    !portfolioCollection.length && !isFormOpened
        ? getPortfolioMonitorOverlay(true, true)
        : <PortfolioContent />
  );
};

export default (props) => (
  <PortfoliosContextProvider purePortfoliosList={ props.purePortfoliosList }>
    <PortfolioMonitorContextProvider>
      <ManagePortfoliosContextProvider>
        <PortfolioMonitor { ...props } />
      </ManagePortfoliosContextProvider>
    </PortfolioMonitorContextProvider>
  </PortfoliosContextProvider>
);
